import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatabasesDisplayGridRowDataFragmentGql } from './DatabasesDisplayGridRowFragmentGql';

export const FlowUpstreamDatabasesQueryGql: DocumentNode = gql`
query FlowUpstreamDatabasesQuery($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!, $publishedConnectionsLineageEnabled: Boolean!) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowDataFragment
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection { totalCount }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection { totalCount }
      }
    }
  }
}
${DatabasesDisplayGridRowDataFragmentGql}
`;
